module.exports = __webpack_public_path__ + "static/img/card_4_1.1268e5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/card_4_1.png
// module id = 35ng
// module chunks = 0